export function normalizeBahrainMobile(value) {
  const ascii = String(value).replace(/[٠-٩]/g, digit => String(digit.charCodeAt(0) - 0x660)).replace(/[۰-۹]/g, digit => String(digit.charCodeAt(0) - 0x6f0)).replace(/[\s()\-\u200e\u200f]/g, '');
  const national = ascii.replace(/^(?:\+973|00973|973)(?=\d{8}$)/, '');
  const mobile = /^(?:3(?:[0-79]\d|8[0-57-9])\d|6(?:3(?:00|33|6[16])|441|6(?:3[03-9]|[69]\d|7[0-689])))\d{4}$/;
  return mobile.test(national) ? `+973${national}` : null;
}

function startSafiPopup() {
  const configNode = document.getElementById('safi-phone-popup-config');
  if (!configNode || window.safiPhonePopup1231024) return;
  window.safiPhonePopup1231024 = true;
  const config = JSON.parse(configNode.textContent);
  const hostId = `app-embed-container-${config.formId}`;
  const storageKey = `safi-popup-${config.formId}-completed`;
  let previouslyCompleted = false;
  try {
    const completedAt = Number(localStorage.getItem(storageKey));
    previouslyCompleted = completedAt > 0 && Date.now() - completedAt < 365 * 86400000;
  } catch {}
  const roots = new WeakSet();
  const forms = new WeakSet();
  const styles = `
    :host {
      --forms-base-font-size: 16px;
      --forms-heading-font-size: 26px;
      --forms-body-font: normal 400 16px SafiCairo, Tahoma, sans-serif;
      --forms-heading-font: normal 700 26px SafiCairo, Tahoma, sans-serif;
      --container-border-radius: 22px;
      --container-max-w: 440px;
      --form-field-border-radius: 12px;
      --button-border-radius: 12px;
      --spacing-size-x: 28px;
      --spacing-size-y: 36px;
    }
    #app-embed { direction: rtl; font-family: SafiCairo, Tahoma, sans-serif; }
    h2 { font: 700 26px/1.6 SafiCairo, Tahoma, sans-serif !important; padding-inline: 12px; }
    p { font-family: SafiCairo, Tahoma, sans-serif !important; line-height: 1.8; }
    form { text-align: right; }
    input, label, button, [role="button"], fieldset span { font-family: SafiCairo, Tahoma, sans-serif !important; }
    input[type="tel"] { direction: ltr; text-align: left; font-size: 18px !important; min-height: 56px; box-sizing: border-box; }
    input[type="checkbox"] { width: 20px; height: 20px; accent-color: #214d3c; }
    fieldset { padding: 4px 0; }
    fieldset label { align-items: flex-start; gap: 10px; line-height: 1.75; font-size: 14px; }
    button[type="submit"] { min-height: 54px; font-size: 17px !important; font-weight: 700; }
    [data-safi-close] { min-width: 44px; min-height: 44px; display: inline-flex; align-items: center; justify-content: center; border-radius: 50%; }
    [data-safi-close]:focus-visible, [data-safi-copy]:focus-visible { outline: 3px solid #214d3c; outline-offset: 3px; }
    [role="dialog"][aria-label] { max-height: calc(100dvh - 32px); overflow-y: auto; }
    [data-safi-disclaimer] { font-size: 12px !important; line-height: 1.8; }
    [data-safi-disclaimer] p { margin-block: 6px; }
    [data-safi-dial] { font: 600 14px/1.4 SafiCairo, Tahoma, sans-serif; direction: ltr; margin-inline-start: 6px; }
    #safi-popup-phone-error { color: #af161d; font: 400 14px/1.8 SafiCairo, Tahoma, sans-serif; text-align: right; margin: 8px 0 0; }
    #safi-popup-phone-error[hidden] { display: none; }
    [data-safi-code] { direction: ltr; font: 700 28px/1.6 ui-monospace, monospace !important; letter-spacing: 4px; border: 1px dashed #214d3c; border-radius: 12px; padding: 12px; background: #fff; margin: 18px 0 10px; user-select: all; }
    [data-safi-copy] { display: block; width: 100%; min-height: 48px; border: 1px solid #214d3c; color: #214d3c; background: transparent; border-radius: 12px; font: 700 16px/1.5 SafiCairo, Tahoma, sans-serif; padding: 12px; cursor: pointer; }
    [data-safi-shop] { display: block; background: #214d3c; color: #fff !important; border-radius: 12px; padding: 14px; min-height: 26px; font-size: 17px; font-weight: 700; text-decoration: none !important; margin-block: 12px 4px; }
    [data-safi-copy-status] { font-size: 13px; margin-block: 4px; min-height: 24px; }
    @media (max-width: 490px) { :host { --spacing-size-x: 22px; --spacing-size-y: 30px; } h2 { font-size: 24px !important; } }
    @media (prefers-reduced-motion: reduce) { * { animation: none !important; transition: none !important; } }
  `;

  function bind(host) {
    const root = host.shadowRoot;
    if (!root || roots.has(root)) return Boolean(root);
    roots.add(root);
    if (previouslyCompleted) {
      host.style.setProperty('display', 'none', 'important');
      return true;
    }
    const style = document.createElement('style');
    style.textContent = styles;
    root.append(style);
    let queued = false;
    let completionRecorded = false;
    const queue = () => {
      if (queued) return;
      queued = true;
      requestAnimationFrame(() => { queued = false; enhance(); });
    };

    function enhance() {
      const app = root.getElementById('app-embed');
      if (!app) return;
      if (app.getAttribute('lang') !== 'ar') app.setAttribute('lang', 'ar');
      if (app.getAttribute('dir') !== 'rtl') app.setAttribute('dir', 'rtl');
      const close = app.querySelector('[role="button"][aria-label="Close modal"]');
      if (close) { close.setAttribute('aria-label', config.close); close.setAttribute('data-safi-close', ''); }
      const form = app.querySelector('form');
      const phone = form?.querySelector('input[name="phone_number"]');
      if (phone) {
        phone.setAttribute('placeholder', '3XXXXXXX');
        phone.setAttribute('inputmode', 'tel');
        phone.setAttribute('dir', 'ltr');
        const country = form.querySelector('button[role="combobox"]');
        if (country && /\+973/.test(country.getAttribute('aria-label') || '')) {
          country.disabled = true;
          country.setAttribute('aria-label', config.country);
          if (!country.querySelector('[data-safi-dial]')) {
            const dial = document.createElement('span');
            dial.setAttribute('data-safi-dial', '');
            dial.textContent = '+973';
            country.append(dial);
          }
        }
        const disclaimer = form.nextElementSibling;
        if (disclaimer && !disclaimer.hasAttribute('data-safi-disclaimer')) disclaimer.setAttribute('data-safi-disclaimer', '');
        if (!forms.has(form)) {
          forms.add(form);
          const error = document.createElement('p');
          error.id = 'safi-popup-phone-error';
          error.setAttribute('role', 'alert');
          error.hidden = true;
          const phoneGroup = phone.closest('div').parentElement;
          phoneGroup.after(error);
          const describedBy = phone.getAttribute('aria-describedby') || '';
          phone.setAttribute('aria-describedby', `${describedBy} ${error.id}`.trim());
          let preparedNumber = null;
          const clearError = () => {
            preparedNumber = null;
            if (error.hidden) return;
            error.hidden = true;
            phone.setAttribute('aria-invalid', 'false');
          };
          phone.addEventListener('input', clearError);
          form.addEventListener('submit', event => {
            const submit = form.querySelector('button[type="submit"]');
            const normalized = normalizeBahrainMobile(phone.value);
            if (!normalized) {
              event.preventDefault();
              event.stopImmediatePropagation();
              error.textContent = config.error;
              error.hidden = false;
              phone.setAttribute('aria-invalid', 'true');
              phone.focus();
              return;
            }
            if (submit?.disabled) {
              event.preventDefault();
              event.stopImmediatePropagation();
              return;
            }
            if (phone.value !== normalized && preparedNumber !== normalized) {
              event.preventDefault();
              event.stopImmediatePropagation();
              Object.getOwnPropertyDescriptor(HTMLInputElement.prototype, 'value').set.call(phone, normalized);
              phone.dispatchEvent(new Event('input', { bubbles: true }));
              phone.dispatchEvent(new Event('change', { bubbles: true }));
              preparedNumber = normalized;
              requestAnimationFrame(() => { if (form.isConnected) form.requestSubmit(submit || undefined); });
            }
          }, true);
        }
      }
      for (const alert of app.querySelectorAll('[role="alert"]')) {
        if (/^(Phone number is required|Enter a valid phone number|Phone number is invalid)\.?$/i.test(alert.textContent.trim())) alert.textContent = config.error;
      }
      if (app.dataset.currentStep !== 'success') return;
      if (!completionRecorded) {
        completionRecorded = true;
        try { localStorage.setItem(storageKey, String(Date.now())); } catch {}
      }
      const code = Array.from(app.querySelectorAll('p')).find(p => p.textContent.trim() === config.discountCode);
      if (code && !code.hasAttribute('data-safi-code')) {
        code.setAttribute('data-safi-code', '');
        code.setAttribute('dir', 'ltr');
        const button = document.createElement('button');
        button.type = 'button';
        button.setAttribute('data-safi-copy', '');
        button.textContent = config.copy;
        const status = document.createElement('p');
        status.setAttribute('role', 'status');
        status.setAttribute('data-safi-copy-status', '');
        status.setAttribute('aria-live', 'polite');
        button.addEventListener('click', async () => {
          try {
            await navigator.clipboard.writeText(config.discountCode);
            status.textContent = config.copied;
          } catch {
            const selection = window.getSelection();
            const range = document.createRange();
            range.selectNodeContents(code);
            selection.removeAllRanges();
            selection.addRange(range);
            status.textContent = config.copyFallback;
          }
        });
        code.after(button, status);
      }
      for (const link of app.querySelectorAll('a[href]')) {
        const url = new URL(link.href, location.origin);
        if (url.origin === location.origin && url.pathname === `/discount/${config.discountCode}` && !link.hasAttribute('data-safi-shop')) link.setAttribute('data-safi-shop', '');
      }
    }
    new MutationObserver(queue).observe(root, { childList: true, subtree: true, characterData: true });
    enhance();
    return true;
  }

  let attempts = 0;
  const attempt = () => {
    const host = document.getElementById(hostId);
    if (host) return bind(host);
    return false;
  };
  const timer = setInterval(() => { if (attempt() || ++attempts >= 120) clearInterval(timer); }, 250);
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.id === hostId || node.querySelector?.(`#${hostId}`))))) attempt();
  }).observe(document.body, { childList: true, subtree: true });
  attempt();
}

if (typeof document !== 'undefined') startSafiPopup();
